import { IconWithTooltip } from "@oysterhr/feature-components"

export const PriceHeader = () => (
  <div>
    Price
    <div className="ml-1 inline">
      <IconWithTooltip
        icon="Question"
        value="Estimated price based on ‘age base’. Click on price for more info."
      />
    </div>
  </div>
)
